/**
* Project Name : cop-web-portal
* File Name : TermPopup.vue
* Description : Term popup in Footer
* Date : 2023.05.12
*/
<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <div class="modal_header">
        <h5>{{ title }}</h5>
        <!-- <div class="form-group form-inline privacy">
        </div> -->

        <select id="termHistory" @change="changeTerm" style="padding:10px 30px 10px 10px;width:300px;">
          <option v-for="(item, idx) in list" :key="item.termsId + idx" :value="item.termsId">{{ termsVersion(item) }}</option>
        </select>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')"></button>
      </div>

      <div class="modal_body">


        <div class="agree_wrap">
          <div class="agree_box">
            <div id="shadowTag"></div>
          </div>
        </div>
        <!-- <p class="mt-4">{{ $t('sdl.common.label.enforcementDate') }} : {{ startDate }}</p> -->
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.close')  }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import SDLUtil from '@/utils/SDLUtil';

export default {
  props: {
    term: {
      required: true,
      type: Object,
    },
    title: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      content: '',
      startDate: '',
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      editorContentStyle: 'getEditorContentStyle',
    }),
  },
  methods: {
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 컴포넌트 init
     * since: 2023.10.17
     */
    init() {
      const term = this.list[0];
      this.content = term.content;
      this.startDate = term.startDate;
      this.setTermsContent(this.content);
    },
    /**
     * param: event
     * return: nothing
     * exception: nothing
     * description: 선택한 이용약관 조회 (get selected terms and condition)
     * since: 2023.05.12
     */
    changeTerm(event) {
      const termsId = event.target.value;
      const term = _.find(this.list, ['termsId', termsId]);
      this.content = term.content;
      this.startDate = term.startDate;
      this.setTermsContent(this.content);
    },
    /**
     * param: item (term Object)
     * return: nothing
     * exception: nothing
     * description: 이용약관 버전 세팅 (set version of terms and condition)
     * since: 2023.05.12
     */
    termsVersion(item) {
      const list = [...this.list];
      const termsList = _.reverse(list);
      const idx = _.findIndex(termsList, { termsId: item.termsId });
      return `v.1.${idx} (${SDLUtil.getMsgProp('sdl.common.label.enforcementDate2')}: ${item.startDate})`;
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: shadow DOM에 content 붙여넣기
     * since: 2023.05.12
     */
    setTermsContent(content) {
      const shadowTag = document.getElementById('shadowTag');
      if (!shadowTag.shadowRoot) {
        shadowTag.attachShadow({ mode: 'open' });
      }
      shadowTag.shadowRoot.innerHTML = this.editorContentStyle + content;
    },
  },
  mounted() {
    this.startDate = this.term.startDate;
    this.content = this.term.content;

    axios
      .get(`${SDLUtil.API_URL}/privacypolicy/terms/${this.term.partId}/prev?langType=${this.term.langType}`)
      .then(({ data }) => {
        this.list = [this.term, ...data];
        this.init();
      })
      .catch(err => {
        console.error(err);
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/popup/TermPopup.vue